<template>
    <div>
        <el-row style="margin-top: 2vh; padding: 20px;">
            <!-- 搜索和操作按钮区域 -->
            <el-col :span="24"
                style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
                <!-- 搜索框：设备序列号查询 -->
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="设备序列号：">
                        <el-input v-model="searchKeyword" placeholder="请输入设备序列号" clearable
                            @keyup.enter.native="handleSearch" style="width: 300px;">
                        </el-input>
                    </el-form-item>
                    <!-- <el-form-item>
                        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
                    </el-form-item> -->
                </el-form>

                <!-- 批量删除按钮 -->
                <el-button type="danger" icon="el-icon-delete" @click="handleBatchDelete"
                    :disabled="!selectedIds.length">
                    批量删除
                </el-button>
            </el-col>

            <!-- 表格区域 -->
            <el-col :span="24" style="margin-top: 20px;">
                <el-table ref="tableRef" :data="paginatedList" height="65vh" style="width: 100%;" border
                    :header-cell-class-name="'table-header'" @row-click="handleRowClick" v-loading="loading"
                    @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column label="序号" type="index" width="70" align="center" />
                    <el-table-column prop="deviceId" label="设备号" align="center" />
                    <el-table-column prop="serialNumber" label="设备序列号" align="center" />
                    <el-table-column prop="alarmName" label="告警名称" align="center" />
                    <el-table-column prop="alarmType" label="告警类型" align="center" />
                    <el-table-column prop="alarmStatus" label="告警状态" align="center" />
                    <el-table-column prop="alarmTime" label="告警时间" align="center" />
                    <el-table-column prop="alarmInfo" label="告警信息" align="center" />
                    <el-table-column label="操作" align="center" width="160" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click="handleDelete(scope.row.id)" type="danger" size="small"
                                icon="el-icon-delete">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页区域 -->
                <div style="margin-top: 20px; text-align: center;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="filteredTotalCount">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { getDeviceAlarm, delDeviceAlarm } from "@/api/alarm";

export default {
    data() {
        return {
            // 表格数据和分页
            list: [], // 原始完整数据
            loading: false,
            currentPage: 1,
            pageSize: 10,

            // 选中的ID数组（批量删除用）
            selectedIds: [],

            // 搜索关键词（用于设备序列号搜索）
            searchKeyword: '',

            // 冗余字段（保留，不影响功能）
            searchForm: {
                houseId: '',
                code: '',
            },
            dialogVisible: false,
            dialogTitle: '新增配件',
            formRef: null,
            form: {
                id: '',
                accessoriesName: '',
                accessoriesType: '',
                remark: '',
                unit: '',
                userid: localStorage.getItem('userId')
            },
            rules: {
                accessoriesName: [{ required: true, message: '请输入配件名称', trigger: 'blur' }],
                accessoriesType: [{ required: true, message: '请输入配件类型', trigger: 'blur' }],
            },
        };
    },
    computed: {
        // 核心修改：仅根据设备序列号（serialNumber）过滤列表
        filteredList() {
            if (!this.searchKeyword) {
                return this.list; // 无关键词时返回全部数据
            }
            // 统一转小写，去除空格，实现不区分大小写+精准模糊匹配
            const keyword = this.searchKeyword.trim().toLowerCase();
            return this.list.filter(item => {
                // 仅匹配设备序列号，空值跳过
                return item.serialNumber && item.serialNumber.toLowerCase().includes(keyword);
            });
        },
        // 过滤后的总数（分页用）
        filteredTotalCount() {
            return this.filteredList.length;
        },
        // 分页后的列表
        paginatedList() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.filteredList.slice(start, end);
        }
    },
    created() {
        this.getList();
    },
    methods: {
        // 获取告警列表数据
        getList() {
            this.loading = true;
            getDeviceAlarm({
                userid: localStorage.getItem('userId')
            }).then(response => {
                this.list = response.data || [];
                // 清空选中状态
                this.selectedIds = [];
                this.$nextTick(() => {
                    if (this.$refs.tableRef) {
                        this.$refs.tableRef.clearSelection();
                    }
                });
            }).catch(error => {
                console.error('获取告警列表失败:', error);
                this.$message.error('获取告警列表失败，请稍后重试');
                this.list = [];
            }).finally(() => {
                this.loading = false;
            });
        },

        // 搜索触发（点击搜索按钮/回车/清空后重置页码）
        handleSearch() {
            this.currentPage = 1; // 搜索后从第一页开始显示
            // 可选：添加搜索提示
            if (this.searchKeyword) {
                console.log(`搜索设备序列号：${this.searchKeyword}`);
            }
        },

        // 切换每页条数
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
        },

        // 切换页码
        handleCurrentChange(val) {
            this.currentPage = val;
        },

        handleRowClick(row) {
            console.log('Row clicked:', row);
        },

        // 监听表格选中事件，更新选中ID数组
        handleSelectionChange(val) {
            this.selectedIds = val.map(item => item.id);
        },

        // 单条删除
        handleDelete(id) {
            this.$confirm('此操作将永久删除该告警记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await this.executeDelete([id]);
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        // 批量删除
        handleBatchDelete() {
            if (!this.selectedIds.length) {
                this.$message.warning('请选择要删除的告警记录');
                return;
            }

            this.$confirm(`此操作将永久删除选中的 ${this.selectedIds.length} 条告警记录, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await this.executeDelete(this.selectedIds);
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        // 统一删除执行方法（传参格式：{ ids: [1] } 或 { ids: [1,2] }）
        async executeDelete(ids) {
            try {
                const response = await delDeviceAlarm({ ids: ids });
                if (response.code === 200 || response.success) {
                    this.$message.success(`成功删除 ${ids.length} 条告警记录`);
                    this.getList(); // 重新加载列表
                } else {
                    this.$message.error(response.msg || response.message || '删除失败');
                }
            } catch (error) {
                console.error("删除告警失败:", error);
                this.$message.error('操作失败，请稍后重试');
            }
        },



    }
};
</script>

<style lang="scss" scoped>
.table-header {
    background-color: rgb(230, 242, 255) !important;
    font-weight: bold;
}

.text-red-500 {
    color: #f56c6c;
}

.demo-form-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
}

// 优化搜索框样式
.el-input {
    --el-input-hover-border-color: #409eff;
}

.el-dialog__body {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
}

.el-form-item {
    margin-bottom: 20px;
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
}
</style>